// src/lib/passwordPolicy.js
// ───────────────────────────────────────────────────────────────────────────
// S4c ítem 3 — política de contraseña (mínimo 12 caracteres) y lógica PURA de la
// rotación guiada. Sin Firebase: testeable en jest.
//
// Modelo de datos en users/{uid} (lo escribe scripts/s4c-password-rotation.mjs):
//   passwordRotation: { requiredAt: Timestamp, version: 1, group: 'admins'|'all' }
//   passwordChangedAt: Timestamp   ← lo escribe el propio usuario al cambiarla
//                                    (MyProfileView → ChangePasswordForm)
// El banner vive mientras requiredAt > passwordChangedAt (o no hay changedAt).
// La política del proyecto en Auth (minLength 12) se activa en el gate POLICY ON,
// después de DEPLOY S4C; mientras tanto el mínimo lo exige este módulo en cliente.
// ───────────────────────────────────────────────────────────────────────────

export const MIN_PASSWORD_LENGTH = 12;

/** Convierte Timestamp de Firestore / Date / número / {seconds} a milisegundos (o null). */
export function toMillis(v) {
    if (v == null) return null;
    if (typeof v === 'number') return v;
    if (v instanceof Date) return v.getTime();
    if (typeof v.toMillis === 'function') return v.toMillis();
    if (typeof v.seconds === 'number') return v.seconds * 1000;
    if (typeof v._seconds === 'number') return v._seconds * 1000;
    const t = Date.parse(v);
    return Number.isNaN(t) ? null : t;
}

/**
 * ¿Debe este usuario cambiar la contraseña? true si hay una rotación pedida y no
 * hay un cambio posterior a la fecha pedida.
 */
export function needsPasswordRotation(userDoc) {
    const required = toMillis(userDoc?.passwordRotation?.requiredAt);
    if (required == null) return false;
    const changed = toMillis(userDoc?.passwordChangedAt);
    return changed == null || changed < required;
}

/**
 * Valida una contraseña nueva. Devuelve { ok, errors: [clave i18n] }.
 * Reglas: ≥ 12 caracteres, distinta de la actual, coincide con la confirmación,
 * y no puede ser el email del usuario.
 */
export function validateNewPassword({ current = '', next = '', confirm = '', email = '' } = {}) {
    const errors = [];
    if (typeof next !== 'string' || next.length < MIN_PASSWORD_LENGTH) errors.push('password.err.tooShort');
    if (next && current && next === current) errors.push('password.err.sameAsCurrent');
    if (next !== confirm) errors.push('password.err.mismatch');
    if (email && next && next.toLowerCase() === String(email).toLowerCase()) errors.push('password.err.isEmail');
    return { ok: errors.length === 0, errors };
}

/** Días restantes hasta un límite (redondeo hacia arriba; negativo si venció). */
export function daysUntil(deadline, now = Date.now()) {
    const d = toMillis(deadline);
    if (d == null) return null;
    return Math.ceil((d - now) / 86400000);
}
